import { ToolsTranslations } from '@/lib/translations/types';
import { DividendYieldValues } from './types';

interface Props {
  values: DividendYieldValues;
  onValuesChange: (field: keyof DividendYieldValues, value: number | string) => void;
  translations: ToolsTranslations['dividendYield'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const formatNumber = (value: number): string => {
    if (value === null || value === undefined) return '';
    try {
      return value.toLocaleString('sv-SE', { maximumFractionDigits: 2 });
    } catch {
      return String(value);
    }
  };

  const parseNumber = (input: string): number => {
    if (!input) return 0;
    const normalized = input.replace(/[^0-9,.-]/g, '').replace(/,/g, '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{translations.pricePerShare}</label>
        <input
          type="text"
          inputMode="decimal"
          className="w-full rounded-md border border-gray-200 bg-white px-4 py-3 text-lg shadow-sm placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
          value={formatNumber(values.pricePerShare)}
          onChange={(e) => onValuesChange('pricePerShare', parseNumber(e.target.value))}
          min={0}
          step="0.01"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{translations.dividendPerShare}</label>
        <input
          type="text"
          inputMode="decimal"
          className="w-full rounded-md border border-gray-200 bg-white px-4 py-3 text-lg shadow-sm placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
          value={formatNumber(values.dividendPerShare)}
          onChange={(e) => onValuesChange('dividendPerShare', parseNumber(e.target.value))}
          min={0}
          step="0.01"
        />
      </div>
    </div>
  );
}


